function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.212-10.257,2.754-12.715a1.406,1.406,0,0,0-.993-.413H-4.219a1.411,1.411,0,0,0-1.406,1.409V.469A1.407,1.407,0,0,0-4.219,1.875H4.219A1.407,1.407,0,0,0,5.625.469V-9.261A1.413,1.413,0,0,0,5.212-10.257Zm-.662.665a.461.461,0,0,1,.123.217h-2.8v-2.8a.461.461,0,0,1,.217.123ZM4.219.937H-4.219A.47.47,0,0,1-4.688.469V-11.719a.47.47,0,0,1,.469-.469H.937v3.047a.7.7,0,0,0,.7.7H4.687V.469A.47.47,0,0,1,4.219.937ZM2.812-6.211a.353.353,0,0,0-.352-.352H-2.461a.353.353,0,0,0-.352.352v.234a.353.353,0,0,0,.352.352H2.461a.353.353,0,0,0,.352-.352Zm0,1.875a.353.353,0,0,0-.352-.352H-2.461a.353.353,0,0,0-.352.352V-4.1a.353.353,0,0,0,.352.352H2.461A.353.353,0,0,0,2.812-4.1Zm0,1.875a.353.353,0,0,0-.352-.352H-2.461a.353.353,0,0,0-.352.352v.234a.353.353,0,0,0,.352.352H2.461a.353.353,0,0,0,.352-.352Z",
  transform: "translate(5.625 13.128)",
  opacity: 0.871
});

var SvgIconSide13 = function SvgIconSide13(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.25,
    height: 15.003,
    viewBox: "0 0 11.25 15.003",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSide13, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-side-13.7257e14d.svg";
export { ForwardRef as ReactComponent };